import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_PAYMENT_CARD_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { LIST_CARDS } from './getListCards';
import type { SubmitUpdateCardRequestPayload, SubmitUpdateCardResult } from '../types/submitUpdateCardRequest.types';

export const submitUpdateCardRequest = (builder: BuilderType) =>
  builder.mutation<SubmitUpdateCardResult, SubmitUpdateCardRequestPayload>({
    invalidatesTags: [LIST_CARDS],
    query: (params) => ({
      data: params,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_PAYMENT_CARD_URL,
    }),
    transformResponse: (response: GenericApiResponse<SubmitUpdateCardResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
